import ContextCard from '@/components/ContextCard/ContextCard'
import { connectCardActivity } from './splitAccessGroups'
import IntegrationAccessGroups from './IntegrationAccessGroups'

export default function IntegrationAccessRequestCards({
  groups,
  connectingToolkit,
  onConnect,
  deferred,
}) {
  if (!groups.length) return null
  return (
    <ContextCard activity={connectCardActivity(groups)} title="Connect apps to proceed">
      <IntegrationAccessGroups
        groups={groups}
        connectingToolkit={connectingToolkit}
        onConnect={onConnect}
        deferred={deferred}
      />
    </ContextCard>
  )
}
